/**
 * Store-owned profile footer nav (injected into SaitoProfile footer slot).
 * @param {Array<{ action: string, label: string, icon: string }>} items
 */
module.exports = function () {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rows = (Array.isArray(items) ? items : []).map(function (item) {
    var action = String((item === null || item === void 0 ? void 0 : item.action) || '').trim();
    var label = String((item === null || item === void 0 ? void 0 : item.label) || '').trim();
    var icon = String((item === null || item === void 0 ? void 0 : item.icon) || '').trim();
    if (!action || !label || !icon) {
      return '';
    }
    return "\n      <div\n        class=\"item\"\n        role=\"button\"\n        tabindex=\"0\"\n        data-nav-action=\"".concat(action, "\"\n      >\n        <span class=\"icon\" aria-hidden=\"true\"><i class=\"").concat(icon, "\"></i></span>\n        <span class=\"label\">").concat(label, "</span>\n      </div>");
  }).filter(Boolean).join('');
  if (!rows) {
    return '';
  }
  return "\n    <nav class=\"user-store-nav saito-menu-select-subtle\" aria-label=\"Store profile\">\n      ".concat(rows, "\n    </nav>\n  ");
};